import React from "react";
import { Outlet } from "react-router-dom";

export const EnsurePlanPaid: React.FC = () => {
  // Eliminada toda la lógica de redirección
  // Ahora permitimos que los usuarios accedan a todas las rutas
  // El chat mostrará el CTA cuando no haya suscripción activa o el trial haya expirado
  // Due Diligence permanece abierto
  return (
    <>
      <Outlet />
    </>
  );
};
